<template>
  <v-container class="sign-up">
    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row v-if="isFirstStep">
      <v-flex xs12 sm6 offset-sm3>
        <snackbar :text="errorText" :color="snackbarColor" :show.sync="showErrorMissingData" :timeOut="2000"></snackbar>
        <h2>Creá tu cuenta</h2>
        <v-container>
          <v-form v-model="validStep1">
            <v-layout row>
              <v-flex xs12>
                <v-text-field prepend-inner-icon="face" name="name" label="Nombre y Apellido" id="name"
                  v-model="name"
                  type="name"
                  :rules="$ponceConfig.requiredRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout class="padding" row>
              <v-flex xs12>
                <v-text-field prepend-inner-icon="email" name="email" label="Email" id="email"
                  v-model="email"
                  type="email"
                  :rules="$ponceConfig.emailRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <h2 class="padding">Definí tu rol</h2>
        <v-container>
          <v-select label="Rol" prepend-icon="person" v-model="selectedRole" item-text="label" item-value="id" :items="allRoles" ></v-select>
          <v-layout row class="create-button">
            <v-flex xs12 sm12>
              <v-btn block color="primary" @click="onContinue()">Continuar</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3>
        <snackbar :text="errorText" :color="snackbarColor" :show.sync="showErrorMissingData" :timeOut="2000"></snackbar>
        <v-form v-model="validStep2">
        <h2>Establecé tu contraseña</h2>
        <v-container>
          <v-layout row>
              <v-flex xs12>
                <v-text-field prepend-inner-icon="lock" name="password" label="Contraseña" id="password"
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  @click:append="showPassword = !showPassword"
                  :rules="$ponceConfig.passwordRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
        </v-container>
        <h2 class="padding">Validación</h2>
        <v-container>
          <v-layout row>
              <v-flex xs12>
                <v-text-field prepend-inner-icon="phone" name="phoneNumber" id="phoneNumber" label="ej: +549223XXXXXXX"
                  v-model="phone"
                  type="phoneNumber"
                  :rules="$ponceConfig.phoneRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="create-button">
            <v-flex xs12 sm12>
              <v-btn block color="primary" @click="onSignup">Crear cuenta</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { CREATE_USER_MUTATION, ALL_ROLES_QUERY, UPDATE_USER_ROLE_MUTATION } from '../../constants/graphql';
  const SnackBar = () => import('../Shared/Snackbar.vue');

  export default {
    data () {
      return {
        step: 1,
        snackbarColor: '',
        name: '',
        email: '',
        password: '',
        showPassword: false,
        phone: '+549',
        errorText: '',
        showErrorMissingData: false,
        selectedRole: '',
        allRoles: [],
        validStep1: '',
        validStep2: ''
      };
    },
    apollo: {
      allRoles: {
        query: ALL_ROLES_QUERY
      }
    },
    mounted () {
      this.$router.push('/signup');
      this.step = 1;
      this.$store.commit('setStep', 1);
      this.$store.commit('setShowStepSignup', true);
    },
    computed: {
      isFirstStep () {
        return this.step === 1;
      },
      currentRoute () {
        return this.$router.currentRoute.fullPath;
      },
      user () {
        return this.$store.getters.user;
      },
      error () {
        return this.$store.getters.error;
      },
      loading () {
        return this.$store.getters.loading;
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.fullPath === '/signup') {
          this.$store.commit('setStep', 1);
          this.step = 1;
        };
      }
    },
    methods: {
      onContinue () {
        if (this.validStep1) {
          this.$store.commit('setStep', 2);
          this.step = 2;
          this.$router.push('/signup2');
        } else {
          this.snackbarColor = 'red';
          this.errorText = 'Por favor complete correctamente sus datos.';
          this.showErrorMissingData = true;
        }
      },
      saveUserData (id, email, token) {
        localStorage.setItem('auth_token', token);
        this.$root.$data.userId = id;
        this.$store.dispatch('signUserIn', { id, email, token });
      },
      onSignup () {
        if (!this.$store.getters.isOnline) {
          this.snackbarColor = 'red';
          this.errorText = 'Sin conexión! Intenta nuevamente más tarde';
          this.showErrorMissingData = true;
          return;
        }
        if (!this.validStep2) {
          this.snackbarColor = 'red';
          this.errorText = 'Por favor complete correctamente sus datos.';
          this.showErrorMissingData = true;
          return;
        }
        const { name, email, password, phone } = this.$data;
        const variables = { name, email, password, phone };
        this.$apollo.mutate({
          mutation: CREATE_USER_MUTATION,
          variables
        }).then((result) => {
          const id = result.data.authenticate.item.id;
          const token = result.data.authenticate.token;
          this.saveUserData(id, email, token);
          if (this.selectedRole !== '') {
            this.$apollo.mutate({
              mutation: UPDATE_USER_ROLE_MUTATION,
              variables: {
                userId: id,
                roleId: this.selectedRole
              }
            }).then(() => {
              this.$router.push({name: 'UserInfo', params: { firstEntry: true }});
            }).catch(() => {
              this.snackbarColor = 'red';
              this.errorText = 'Server Error';
              this.showErrorMissingData = true;
            });
          } else {
            this.$router.push({name: 'UserInfo', params: { firstEntry: true }});
          }
          this.$store.commit('setShowStepSignup', false);
        }).catch((error) => {
          this.errorText = 'Server error  ';
          if (error.graphQLErrors && error.graphQLErrors[0] && error.graphQLErrors[0].extensions.exception.constraint) {
            this.errorText = 'El email ingresado ya se encuentra en uso';
          }
          this.snackbarColor = 'red';
          this.showErrorMissingData = true;
        });
      },
      onDismissed () {
        this.$store.dispatch('clearError');
      }
    },
    components: {
      'snackbar': SnackBar
    }
  };
</script>



// WEBPACK FOOTER //
// Signup.vue?12277476